var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6587 5.32031C23.6587 5.00293 23.4673 4.71729 23.1738 4.59668L12.1265 0.0585938C11.936 -0.0195312 11.7227 -0.0195312 11.5322 0.0585938L0.484863 4.59717C0.191406 4.71729 0 5.00342 0 5.32031V19.6792C0 19.9966 0.191406 20.2822 0.484863 20.4028L11.5322 24.9409C11.7207 25.0181 11.9326 25.02 12.1255 24.9409C12.1348 24.938 11.7168 25.1094 23.1738 20.4028C23.4673 20.2822 23.6587 19.9966 23.6587 19.6792V5.32031ZM11.8296 9.0791L7.75928 7.40674L16.5557 3.56934L20.8984 5.35352L11.8296 9.0791ZM1.56445 6.55322L5.07617 7.99609V12.0664C5.07617 12.4985 5.42627 12.8486 5.8584 12.8486C6.29053 12.8486 6.64062 12.498 6.64062 12.0659V8.63818L11.0474 10.4487V23.0508L1.56445 19.1553V6.55322ZM11.8296 1.62793L14.541 2.7417L5.74414 6.5791L2.76074 5.35352L11.8296 1.62793ZM12.6113 10.4487L22.0942 6.55322V19.1553L12.6113 23.0508V10.4487Z",
    fill: "#575757"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.6587,
    height: 25,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.286c459d.svg";
export { ForwardRef as ReactComponent };